// ChargeabilityPage.jsx

// Dependencies
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

// Components
import Chargeability from '@/components/data/chargeability/Chargeability';
import LoadingOverlay from '@/components/common/LoadingOverlay';

// Services
import { getChargeabilityReport } from '@/services/schedulingService';

// Styling
import { chargeabilityCss } from '@digital_monorepo/styling';

const LEGEND = [
  { className: chargeabilityCss.heat0, label: '<20%' },
  { className: chargeabilityCss.heat1, label: '20–40%' },
  { className: chargeabilityCss.heat2, label: '40–60%' },
  { className: chargeabilityCss.heat3, label: '60–80%' },
  { className: chargeabilityCss.heat4, label: '≥80%' },
];

const ChargeabilityPage = () => {
  const { t } = useTranslation();

  const [report, setReport] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;

    async function fetchData() {
      try {
        const result = await getChargeabilityReport();
        if (!cancelled) setReport(result);
      } catch (err) {
        console.error('Error fetching chargeability report:', err);
        if (!cancelled) setError(err);
      } finally {
        if (!cancelled) setLoading(false);
      }
    }

    fetchData();
    return () => { cancelled = true; };
  }, []);

  return (
    <div className={chargeabilityCss.pageContainer}>

      <div className={chargeabilityCss.header}>
        <div className={chargeabilityCss.titleBlock}>
          <h1 className={chargeabilityCss.title}>{t('CHARGEABILITY.TITLE')}</h1>
        </div>

        <div className={chargeabilityCss.legend}>
          {LEGEND.map(item => (
            <span key={item.label} className={chargeabilityCss.legendItem}>
              <span className={`${chargeabilityCss.legendSwatch} ${item.className}`} />
              {item.label}
            </span>
          ))}
        </div>
      </div>

      {loading && <LoadingOverlay />}

      {!loading && error && (
        <div className={chargeabilityCss.tableWrapper}>
          <div className={chargeabilityCss.stateBox}>{t('CHARGEABILITY.ERROR')}</div>
        </div>
      )}

      {!loading && !error && <Chargeability report={report} />}
    </div>
  );
};

export default ChargeabilityPage;
